// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8cf46b51","181":"315d643a","235":"c16c7baa","288":"6ab3488a","302":"42a295cd","312":"cb58eb9b","326":"23723f00","490":"37203106","579":"55df9039","671":"5db233b1","732":"52252129","740":"3bf97f8b","897":"7dcd44f9","903":"ef875128","919":"e9a04744"}[chunkId] + ".chunk.js";
};